var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"bubblingG"},[_c('span',{attrs:{"id":"bubblingG_1"}}),_c('span',{attrs:{"id":"bubblingG_2"}}),_c('span',{attrs:{"id":"bubblingG_3"}})])])
}]

export { render, staticRenderFns }